import * as momentTimeZone from "moment-timezone";

import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { AppSettings } from "../../../app.settings";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Settings } from "../../../app.settings.model";
import { StorageService } from "../../../services/branchstorage.service";
import { TranslateService } from "@ngx-translate/core";
import axios from "axios";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {
  userRights: any = [];
  public form: FormGroup;
  public settings: Settings;
  public isAuthenticated = false;
  public selectedCustomerBranchId = 0;
  public customerBranch = null;
  public loggedUser = null;
  public token = null;
  public expiarytime = null;
  constructor(
    private _snackBar: MatSnackBar,
    public appSettings: AppSettings,
    public fb: FormBuilder,
    public router: Router,
    private bService: StorageService,
    private translate: TranslateService
  ) {
    const token = localStorage.getItem("userToken");
    const selectedBranch = localStorage.getItem("selectedCustomerBranch");
    if (token && selectedBranch) {
      this.bService.setBranch = JSON.parse(selectedBranch);
      this.router.navigate(["/portal/sales/job-order"]);
    }
    this.settings = this.appSettings.settings;
    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required])],
      password: [
        null,
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
    });
  }
  ngOnInit(): void {
    this.settings.loadingSpinner = false;
    localStorage.removeItem("userData");
    localStorage.removeItem("userToken");
    localStorage.removeItem("selectedCustomerBranch");
    localStorage.removeItem("userRights");
    localStorage.removeItem("vendorFilters");
    localStorage.removeItem("rxgrouping");
    localStorage.removeItem("tokenExpireIn");
  }
  selectCustomerBranch() {
    if (this.selectedCustomerBranchId > 0) {
      const getCustomerBranch = this.customerBranch.filter((x) => {
        return x.customerBranchId === this.selectedCustomerBranchId;
      });
      localStorage.setItem(
        "selectedCustomerBranch",
        JSON.stringify(getCustomerBranch[0])
      );
      this.bService.setBranch = getCustomerBranch[0];
      this.router.navigate(["/portal/sales/job-order"]);
      // this.configureRequestHeader();
      // Add languages
      this.translate.addLangs(["en", "ksa"]);

      // Set the default language
      this.translate.setDefaultLang("en");

      // Use a language
      this.translate.use("en");
      const expiresIn = Math.floor(this.expiarytime / 1000);
      localStorage.setItem("tokenExpireIn", expiresIn.toString());

      // JSON.parse(localStorage.getItem('userData')).userId
      // axios.get('Account/GetUserRightByBranchId?userId='+this.loggedUser.userId+'&branchId='+this.selectedBranchId).then((response) => {
      //     if (response.data.completed) {
      //        this.userRights = response.data.payload;
      //        localStorage.setItem('userRights', JSON.stringify(this.userRights));
      //        this.router.navigate(['/portal/dashboard']);
      //     } else {
      //         this.settings.loadingSpinner = false;
      //         this._snackBar.open(response.data.message, '', {
      //             duration: 3000
      //         });
      //     }
      // });
      // Set Selected Company Branch & User

      // To user Token for upcoming Requests
    }
  }
  public onSubmit(values: Object): void {
    if (this.form.valid) {
      this.settings.loadingSpinner = true;
      let model = {
        userName: this.form.value.email,
        password: this.form.value.password,
      };
      axios.post("CustomerPortal/Login", model).then((response) => {
        if (response.data.completed) {
          this.settings.loadingSpinner = false;
          this._snackBar.open("Successfully Authenticated!", "", {
            duration: 1500,
          });
          this.loggedUser = response.data.payload;
          this.token = response.data.payload.userToken;
          this.customerBranch = response.data.payload.customerBranch;
          this.selectedCustomerBranchId =
            response.data.payload.customerBranch[0].customerBranchId;
          this.customerBranch.map((item) => {
            item["companyId"] = response.data.payload.companyId;
          });
          localStorage.setItem("userData", JSON.stringify(this.loggedUser));
          localStorage.setItem("userToken", this.token);
          this.isAuthenticated = true;
          this.expiarytime = new Date(response.data.payload.expiresIn);
          console.info("routing");
        } else {
          this.settings.loadingSpinner = false;
          this._snackBar.open("Invalaid User Name Or password", "", {
            duration: 3000,
          });
        }
      });
    }
  }
  configureRequestHeader() {
    let isRefreshing = false;
    axios.interceptors.request.use(
      function (config) {
        // var currentDate = momentTimeZone(new Date())
        //   .tz("Asia/Riyadh")
        //   .format("MM-DD-YYYY HH:mm:ss") as any;
        // var tokenExpiaryInSec =
        //   parseInt(localStorage.getItem("tokenExpireIn")) -
        //   Math.floor((new Date(currentDate) as any) / 1000);
        // if (
        //   tokenExpiaryInSec > 0 &&
        //   tokenExpiaryInSec <= 600 &&
        //   !isRefreshing
        // ) {
        //   isRefreshing = true;
        //   const payload = {
        //     userToken: localStorage.getItem("token"),
        //   };
        //   return axios.post("Account/RefreshToke", payload).then((response) => {
        //     if (response.status == 200) {
        //       localStorage.setItem("token", response.data.payload.userToken);
        //       var expiarytime = null;
        //       expiarytime = new Date(response.data.payload.expiresIn);
        //       var expiresIn = Math.floor(expiarytime / 1000);
        //       localStorage.setItem("tokenExpireIn", expiresIn.toString());
        //       isRefreshing = false;
        //       config.headers.common[
        //         "Authorization"
        //       ] = `Bearer ${localStorage.getItem("token")}`;
        //       return config;
        //     }
        //   });
        // }
        // Do something before request is sent
        config.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
          "token"
        )}`;
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );
  }
  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }
}
